import http from "../httpService";
import { apiUrl } from "../../../config.js";

const apiEndpoint = apiUrl + "/crm/sales-journey/";

export function saveSalesJourney(journey) {
  return http.post(apiEndpoint, journey);
}

export function getSalesJourney() {
  return http.get(apiEndpoint);
}

export function getJourneyStocksWarehouse(journeyID, warehouseID) {
  return http.get(
    apiEndpoint + "journey-stocks-warehouse/" + journeyID + "/" + warehouseID
  );
}

export function getVisitDirectSales(directSalesID = 0) {
  return http.get(apiEndpoint + "visit-direct-sales/" + directSalesID);
}

export function getJourneyStocks(journeyID, statusID) {
  return http.get(apiEndpoint + "journey-stocks/" + journeyID + "/" + statusID);
}

export function getJourneyDetail(journeyID) {
  return http.get(apiEndpoint + "journey-detail/" + journeyID);
}

export function getJourneyVisits(journeyID) {
  return http.get(apiEndpoint + "journey-visits/" + journeyID);
}

export function getJourneyTeams(journeyID) {
  return http.get(apiEndpoint + "journey-teams/" + journeyID);
}

export function saveJourneyTeam(team) {
  return http.post(apiEndpoint + "journey-team", team);
}

export function saveJourneyVisits(visits) {
  return http.post(apiEndpoint + "journey-visits", visits);
}

export function saveJourneyStocks(stocks) {
  return http.post(apiEndpoint + "journey-stocks", stocks);
}

export function saveJourneyStocksUnload(stocks) {
  return http.post(apiEndpoint + "journey-stocks-unload", stocks);
}

export function saveVisitActivities(activities) {
  return http.post(apiEndpoint + "visit-activities", activities);
}

export function saveVisitDirectSales(directSales) {
  return http.post(apiEndpoint + "visit-direct-sales", directSales);
}

export function updateVisitStatus(visit) {
  return http.post(apiEndpoint + "update-visit-status", visit);
}

export function updateJourneyStatus(journey) {
  return http.post(apiEndpoint + "update-journey-status", journey);
}

export function getVisitDetail(visitID) {
  return http.get(apiEndpoint + "visit-detail/" + visitID);
}

export function saveActivityTasks(tasks) {
  return http.post(apiEndpoint + "activity-tasks", tasks);
}

export function getJourneyStocksUnload(journeyStockID) {
  return http.get(apiEndpoint + "journey-stocks-unload/" + journeyStockID);
}

export function getVisitActivityTasks(visitActivityID) {
  return http.get(apiEndpoint + "visit-activity-tasks/" + visitActivityID);
}

export function cancelJourneyStock(requestID) {
  return http.delete(apiEndpoint + "journey-stock/" + requestID);
}

export function deleteSalesJourney(journeyID = 0) {
  return http.delete(apiEndpoint + "sales-journey/" + journeyID);
}

export function deleteVisit(visitID = 0) {
  return http.delete(apiEndpoint + "visit/" + visitID);
}

export function deleteVisitActivity(activityID = 0) {
  return http.delete(apiEndpoint + "visit-activity/" + activityID);
}

export function updateSalesJourney(salesJourney) {
  return http.put(apiEndpoint, salesJourney);
}

export function updateSalesVisit(visit) {
  return http.put(apiEndpoint + "visit", visit);
}

export function saveSalesVisit(visit) {
  return http.post(apiEndpoint + "visit", visit);
}
